import type {TypedRoute} from '@typed-router';
import type {RouteLocationNormalizedLoaded} from 'vue-router';
import {useGuestHost, useRuntimeConfig} from '#imports';

export function useExtractQueryParameters(route: RouteLocationNormalizedLoaded | TypedRoute): string {
    const config = useRuntimeConfig();
    const baseURL = config.app.baseURL;
    let searchParams = buildURL(useGuestHost(), baseURL, route.fullPath).search;
    if (searchParams.startsWith('?')) {
        searchParams = searchParams.substring(1);
    }

    return searchParams;
}

export function useExtractQueryParametersAsSearchParams(route: RouteLocationNormalizedLoaded | TypedRoute): URLSearchParams {
    const config = useRuntimeConfig();
    const baseURL = config.app.baseURL;
    return buildURL(useGuestHost(), baseURL, route.fullPath).searchParams;
}

function buildURL(host: string, baseURL: string, fullPath: string): URL {
    return new URL(`${host}${baseURL}${fullPath}`);
}
